import { useState, useEffect, useCallback, useRef } from 'react';
import { panchangService } from '../../../../services/api';
import config from '../../../../config';

const DEBOUNCE_MS = config.vedic?.placeDebounceMs || 300;

export default function usePanchangamData({ lat, lon, timezone, date, ayanamsa, siddhanta }) {
  const [mode, setMode] = useState('single');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const debounceRef = useRef(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      let res;
      let nextMode;

      if (siddhanta === 'compare') {
        // Compare mode — omit ayanamsa (Vakyam has its own traditional ayanamsa)
        res = await panchangService.compare({
          date, lat, lng: lon, tz: timezone, type: 'siddhanta',
        });
        nextMode = 'compare';
      } else {
        // Single mode — include siddhanta only if explicitly set
        const params = { date, lat, lng: lon, tz: timezone, ayanamsa };
        if (siddhanta === 'drik' || siddhanta === 'vakyam') {
          params.siddhanta = siddhanta;
        }
        // When siddhanta is undefined (default first load), no siddhanta param sent.
        // Backend's empty-string fall-through preserves existing cache keys.
        res = await panchangService.getDaily(params);
        nextMode = 'single';
      }

      setData(res.data?.data || res.data);
      setMode(nextMode);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch panchangam');
    } finally {
      setLoading(false);
    }
  }, [lat, lon, timezone, date, ayanamsa, siddhanta]);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(fetchData, DEBOUNCE_MS);
    return () => clearTimeout(debounceRef.current);
  }, [fetchData]);

  return { mode, data, loading, error, refetch: fetchData };
}
